import PropTypes from "prop-types";

const Divider = ({className = "", style = {}, noMargin = false, margin = "10px"}) => {
  return (
    <div
      className={`w100 ${className}`}
      style={{
        borderTop: "1px solid #A3B9D9",
        boxShadow: "var(--dividerShadow)",
        height: 0,
        marginTop: noMargin ? 0 : margin,
        marginBottom: noMargin ? 0 : margin,
        ...style,
      }}
    ></div>
  );
};

Divider.propTypes = {className: PropTypes.string, style: PropTypes.object};

export default Divider;
